module.exports = __webpack_public_path__ + "static/media/LiveNews.fb0acc97.jpg";